<nb-card class="confirmation-dialog">
  <!-- <nb-card-header>{{ title }}</nb-card-header> -->
  <nb-card-body>
    <div style="color: #000;

        text-align: center;
        font-family: Figtree;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
            padding-top: 28px;">
      Are you sure you want to approve the request?
    </div>
  </nb-card-body>
  <nb-card-footer style="border-top: none;">
    <div fxLayout="row" fxLayoutAlign="space-around center" style="margin: 24px 8px;">
      <button nbButton  (click)="dismiss()" style="border-radius: 4px;
        border: 1px solid rgba(0, 63, 114, 0.40);

        background: #FFF;
        color: #494949;

text-align: center;
font-family: Figtree;
font-size: 12px;
font-style: normal;
font-weight: 600;
line-height: 20px;
padding: 12px 48px;
">Cancel</button>
      <button (click)="confirm(forexApprovalData?.forexId)" nbSpinnerStatus="primary" nbButton style="border-radius: 4px;
    border-color: #23DCE1;
    background: #23DCE1;
    color: #494949;
    text-align: center;
    font-family: Figtree;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    padding: 12px 48px;
    ">Confirm</button>
    </div>
    
  </nb-card-footer>
</nb-card>